import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; 
import axios from 'axios';
import '../../../assests/css/customer/Order.css';
import UserMasterLayout from '../../../Layouts/UserMasterLayout/UserMasterLayout';
import AppContext from '../../../context/AppContext';

const Orders = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles, customer } = useContext(AppContext);

  const customerId = customer?.id || null;

  const [filters, setFilters] = useState({ orderId: '', orderName: '', status: '' });
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  // ── Order chat state ──
  const [activeChatOrder, setActiveChatOrder] = useState(null);
  const [chatMessages, setChatMessages]       = useState([]);
  const [conversationId, setConversationId]   = useState(null);
  const [chatMessage, setChatMessage]         = useState('');
  const [selectedImage, setSelectedImage]     = useState(null);
  const [imagePreview, setImagePreview]       = useState(null);
  const fileInputRef = useRef(null);

   const viewAllOrders = () => {
    if (!customerId) return;
    setLoading(true);
    const formdata = new FormData();
    formdata.append("mlcustomer_id", customerId);

    axios.post(`${baseUrl}/customer/order/viewallorder`, formdata)
      .then((response) => {
        setOrders(response.data.order);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { 
    viewAllOrders(); 
  }, [customerId, baseUrl]);

  const handleCancelOrder = async (orderId) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Cancel Order?',
      text: 'Kya aap sure hain?',
      showCancelButton: true,
      confirmButtonText: 'Haan, Cancel karo',
      cancelButtonText: 'Nahi',
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#E3CAA5'
    });

    if (!result.isConfirmed) return;

    const formdata = new FormData();
    formdata.append("order_id", orderId);

    axios.post(`${baseUrl}/customer/order/cancleorder`, formdata)
      .then(() => {
        viewAllOrders();
        Swal.fire('Cancelled!', 'Order cancel hogaya', 'success');
      })
      .catch(() => {
        Swal.fire('Error!', 'Kuch masla hua', 'error');
      });
  };

  
  useEffect(() => { applyFilters(); }, [filters, orders]);

  const applyFilters = () => {
    let filtered = [...orders];

    if (filters.orderId) {
      filtered = filtered.filter(order =>
        order.id.toString().includes(filters.orderId.toString())
      );
    }

    if (filters.orderName) {
      filtered = filtered.filter(order =>
        order.city?.toLowerCase().includes(filters.orderName.toLowerCase())
      );
    }  

    if (filters.status) {
      filtered = filtered.filter(order =>
        order.status === filters.status
      );
    }

    setFilteredOrders(filtered);
  }; 

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleClear = () => {
    setFilters({ orderId: '', orderName: '', status: '' });
  };

  const handleSearch = () => { applyFilters(); };

    const handleViewOrder = (orderId) => {
    const order = filteredOrders.find(o => o.id === orderId);
    if (!order) return;

    Swal.fire({
      title: `<strong>Order #${order.id}</strong>`,
      icon: 'info',
      html: `
        <div style="text-align: left; padding: 10px;">
          <p><strong>Status:</strong> ${order.status}</p>
          <p><strong>Total:</strong> PKR ${order.total}</p>
          <p><strong>Address:</strong> ${order.address}, ${order.city}</p>
          <p><strong>Phone:</strong> ${order.phone}</p>
          <p><strong>Payment:</strong> ${order.paymentMethod}</p>
          <p><strong>Order Date:</strong> ${order.created_at}</p>
        </div>
      `,
      confirmButtonText: 'Close',
      confirmButtonColor: '#E3CAA5',
    });
  };

  // ── Chat: fetch conversation for this order ──
  const fetchOrderConversation = (order) => {
    if (!baseUrl || !order) return;
    axios
      .post(`${baseUrl}/customer/order/fetchConversation`, {
        mlorder_id:    order.id,
        mlcustomer_id: customerId,
      })
      .then((response) => {
        if (response.data.success) {
          const conversation = response.data.conversation;
          setConversationId(conversation.id);
          const newMessages = conversation.Mlchats || conversation.mlchats || [];
          setChatMessages((prev) => {
            if (prev.length === newMessages.length) return prev;
            return newMessages;
          });
        }
      })
      .catch((error) => {
        console.error('fetchOrderConversation error:', error);
      });
  };

  // ── Chat: open detail view ──
  const openOrderChat = (order) => {
    setActiveChatOrder(order);
    setChatMessages([]);
    setConversationId(null);
    handleRemoveImage();
  };

  const closeOrderChat = () => {
    setActiveChatOrder(null);
    setChatMessages([]);
    setConversationId(null);
    handleRemoveImage();
  };

  // ── Chat: polling every 3s while open ──
  useEffect(() => {
    if (!activeChatOrder) return;

    fetchOrderConversation(activeChatOrder);

    const interval = setInterval(() => {
      fetchOrderConversation(activeChatOrder);
    }, 3000);

    return () => clearInterval(interval);
  }, [activeChatOrder]);

  // ── Chat: image select ──
  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  // ── Chat: send message (text and/or image) ──
  const handleSendChatMessage = () => {
    if (!chatMessage.trim() && !selectedImage) return;
    if (!conversationId) return;

    const payload = new FormData();
    payload.append('Mlconversation_id', conversationId);
    payload.append('message', chatMessage);
    if (selectedImage) payload.append('image', selectedImage);

    axios
      .post(`${baseUrl}/customer/order/sendMessage`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => {
        if (response.data.success) {
          setChatMessages((prev) => [...prev, response.data.message]);
          setChatMessage('');
          handleRemoveImage();
        }
      })
      .catch((error) => {
        console.error('sendMessage error:', error);
      });
  };

  const handleChatKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSendChatMessage(); }
  };

  const getImageUrl = (path) => (path.startsWith('http') ? path : `${baseUrlForFiles}/${path}`);

  const getStatusClass = (status) => {
    switch (status) {
      case 'Processing': return 'uo-status-pending';
      case 'Shipped':    return 'uo-status-shipping';
      case 'Delivered':  return 'uo-status-received';
      case 'Cancelled':  return 'uo-status-cancel';
      default: return '';
    }
  };

  // ── CHAT DETAIL VIEW ──
  if (activeChatOrder) {
    return (
      <UserMasterLayout>
        <div className="uo-container">

          <div className="oc-breadcrumb">
            <span className="oc-breadcrumb-link" onClick={closeOrderChat}>Order History</span>
            <span className="oc-breadcrumb-sep">/</span>
            <span className="oc-breadcrumb-current">Order #{activeChatOrder.id}</span>
          </div>

          <div className="oc-header">
            <div>
              <div className="oc-title-row">
                <h1 className="oc-title">Order #{activeChatOrder.id}</h1>
                <span className={`uo-status-badge ${getStatusClass(activeChatOrder.status)}`}>
                  {activeChatOrder.status}
                </span>
              </div>
              <p className="oc-subject">{activeChatOrder.address}, {activeChatOrder.city}</p>
            </div>
            <button className="oc-back-btn" onClick={closeOrderChat}>
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                <path d="M12 6l-4 4 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Back to orders
            </button>
          </div>

          <div className="oc-card">
            <div className="oc-msg-timestamp">
              ORDER PLACED — {activeChatOrder.created_at ? new Date(activeChatOrder.created_at).toLocaleString() : 'N/A'}
            </div>

            <div className="oc-msg-list">
              {chatMessages.length === 0 && (
                <p className="oc-msg-empty">No messages yet.</p>
              )}
              {chatMessages.map((msg, i) => (
                <div key={msg.id || i} className={`oc-msg ${msg.sender === 'customer' ? 'oc-msg--customer' : 'oc-msg--support'}`}>
                  <div className="oc-msg-header">
                    <span className="oc-msg-sender">
                      {msg.sender === 'customer' ? 'You' : 'Admin Support'}
                    </span>
                    <span className="oc-msg-time">
                      {msg.created_at
                        ? new Date(msg.created_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
                        : ''}
                    </span>
                  </div>
                  {msg.image && (
                    <img
                      src={getImageUrl(msg.image)}
                      alt="attachment"
                      className="oc-msg-image"
                      onClick={() => window.open(getImageUrl(msg.image), '_blank')}
                    />
                  )}
                  {msg.message && <div className="oc-msg-text">{msg.message}</div>}
                </div>
              ))}
            </div>

            {imagePreview && (
              <div className="oc-image-preview">
                <img src={imagePreview} alt="preview" />
                <button type="button" className="oc-image-remove" onClick={handleRemoveImage}>×</button>
              </div>
            )}

            <div className="oc-input-bar">
              <button className="oc-attach-btn" onClick={() => fileInputRef.current?.click()}>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                  <path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z" stroke="currentColor" strokeWidth="1.5"/>
                </svg>
              </button>
              <input type="file" ref={fileInputRef} accept="image/*" style={{ display: 'none' }} onChange={handleImageSelect} />
              <input
                type="text"
                className="oc-msg-input"
                placeholder="Write a message..."
                value={chatMessage}
                onChange={(e) => setChatMessage(e.target.value)}
                onKeyDown={handleChatKeyDown}
              />
              <button className="oc-send-btn" onClick={handleSendChatMessage}>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                  <path d="M18 2L9 11M18 2l-7 16-2-7-7-2 16-7z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

        </div>
      </UserMasterLayout>
    );
  }

  // ── ORDER LIST VIEW ──
  return (
    <UserMasterLayout>
      <div className="uo-container">

        {/* Header */}
        <div className="uo-header">
          <h1 className="uo-title">Order History</h1>
        </div>

        {/* Filters */}
        <div className="uo-filters-card">
          <div className="uo-filters-grid">

            <div className="uo-filter-group">
              <label className="uo-filter-label">ORDER ID</label>
              <input
                type="text"
                className="uo-filter-input"
                placeholder="Search by ID"
                value={filters.orderId}
                onChange={(e) => handleFilterChange('orderId', e.target.value)}
              />
            </div>

            <div className="uo-filter-group">
              <label className="uo-filter-label">CITY</label>
              <input
                type="text"
                className="uo-filter-input"
                placeholder="Search by city"
                value={filters.orderName}
                onChange={(e) => handleFilterChange('orderName', e.target.value)}
              />
            </div>

            <div className="uo-filter-group">
              <label className="uo-filter-label">STATUS</label>
              <select
                className="uo-filter-input"
                value={filters.status}
                onChange={(e) => handleFilterChange('status', e.target.value)}
              >
                <option value="">All</option>
                <option value="Processing">Processing</option>
                <option value="Shipped">Shipped</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
              </select>
            </div>

            <div className="uo-filter-buttons-mobile">
              <button className="uo-clear-btn" onClick={handleClear}>CLEAR</button>
              <button className="uo-search-btn" onClick={handleSearch}>SEARCH</button>
            </div>
          </div>

          <div className="uo-filter-buttons">
            <button className="uo-clear-btn" onClick={handleClear}>CLEAR</button>
            <button className="uo-search-btn" onClick={handleSearch}>SEARCH</button>
          </div>
        </div>

        {/* Orders Table */}
        <div className="uo-table-container">
          {loading ? (
            <p style={{ textAlign: 'center', padding: '30px' }}>Loading orders...</p>
          ) : filteredOrders.length > 0 ? (
            <table className="uo-table">
              <thead>
                <tr className="uo-table-header">
                  <th>ORDER ID</th>
                  <th>CITY</th>
                  <th>STATUS</th>
                  <th>TOTAL AMOUNT</th>
                  <th>SHIPPING ADDRESS</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.map((order) => (
                  <tr key={order.id} className="uo-table-row">
                    <td className="uo-id">#{order.id}</td>
                    <td className="uo-order-name">{order.city}</td>
                    <td>
                      <span className={`uo-status-badge ${getStatusClass(order.status)}`}>
                        {order.status}
                      </span>
                    </td>
                    <td className="uo-total">PKR {order.total}</td>
                    <td className="uo-address">{order.address}, {order.city}</td>
                    <td>
                      <div className="uo-action-buttons">
                        <button
                          className="uo-view-btn"
                          onClick={() => handleViewOrder(order.id)}
                        >
                          VIEW
                        </button>
                        <button
                          className="uo-chat-btn"
                          title="Chat about this order"
                          onClick={() => openOrderChat(order)}
                        >
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
                          </svg>
                        </button>
                        {order.status === "Processing" && (
                          <button
                            className="uo-reorder-btn"
                            onClick={() => handleCancelOrder(order.id)}
                          >
                            CANCEL
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="uo-no-results">
              <p>No orders found matching your search criteria.</p>
              <button className="uo-clear-btn" onClick={handleClear} style={{ marginTop: '20px' }}>
                CLEAR FILTERS
              </button>
            </div>
          )}
        </div>

      </div>
    </UserMasterLayout>
  );
};  

export default Orders;